import React, { useState } from "react";
import { Box, Button, TextField } from "@material-ui/core";
import { CheckCircle, Cancel, Edit, RateReview } from "@material-ui/icons";

import SectionCard from "../../utils/SectionCard";
import {
  REVIEW_ACTION_ACCEPT,
  REVIEW_ACTION_REJECT,
  REVIEW_ACTION_ADJUST_REQUEST,
} from "../../../../constants/projectStatus";

// ReviewForm — component dùng chung cho mọi vòng duyệt (R3).
// 3 nút cố định: Duyệt / Yêu cầu chỉnh sửa / Loại. Comment bắt buộc với 2 nhánh sau.
export default function ReviewForm({ onReview, title = "Duyệt", rejectLabel = "Loại" }) {
  const [comment, setComment] = useState("");
  const [pending, setPending] = useState(null);

  const handle = async (action) => {
    if (
      (action === REVIEW_ACTION_ADJUST_REQUEST || action === REVIEW_ACTION_REJECT) &&
      !comment.trim()
    ) {
      alert("Vui lòng nhập nhận xét / lý do.");
      return;
    }
    setPending(action);
    try {
      await onReview(action, comment);
    } finally {
      setPending(null);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<RateReview />} title={title} marginTop={0}>
        <TextField
          fullWidth
          multiline
          minRows={4}
          variant="outlined"
          label="Nhận xét / lý do"
          placeholder="Bắt buộc khi Yêu cầu chỉnh sửa hoặc Loại"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </SectionCard>

      <Box
        marginTop={3}
        paddingTop={2}
        display="flex"
        gridGap={12}
        justifyContent="flex-end"
        borderTop="solid 1px #e0e0e0"
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "#b52f2f", color: "#fff" }}
          startIcon={<Cancel />}
          disabled={pending !== null}
          onClick={() => handle(REVIEW_ACTION_REJECT)}
        >
          {rejectLabel}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<Edit />}
          disabled={pending !== null}
          onClick={() => handle(REVIEW_ACTION_ADJUST_REQUEST)}
        >
          Yêu cầu chỉnh sửa
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<CheckCircle />}
          disabled={pending !== null}
          onClick={() => handle(REVIEW_ACTION_ACCEPT)}
        >
          Duyệt
        </Button>
      </Box>
    </Box>
  );
}
